import React, { useEffect, useState } from 'react';
import axios from 'axios';
import InternalBanner from './InternalBanner';
import { useNavigate } from 'react-router-dom';
import SkelotonEffect from './SkelotonEffect';

export default function Gallery() {


    const navigate = useNavigate();
    const [eventsByYear, setEventsByYear] = useState([]);
    const apiKey = process.env.REACT_APP_API_KEY;
    const baseURL = process.env.REACT_APP_BASE_URL;
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchEventData = async () => {
            try {
                const response = await axios.get(`${baseURL}/get-event_images`, {
                    headers: {
                        accept: 'application/json',
                        Authorization: apiKey,
                    },
                });

                // Sort events and years in descending order
                const sortedData = response.data.events_by_year.map(yearObj => ({
                    ...yearObj,
                    events: yearObj.events.sort((a, b) => new Date(b.event_date) - new Date(a.event_date))
                })).sort((a, b) => b.year - a.year);

                setEventsByYear(sortedData);
            } catch (error) {
                console.error('Error fetching events:', error);
            }
            finally {
                setLoading(false);
            }
        };

        fetchEventData();
    }, [apiKey, baseURL]);


    const handleClick = (images, name, venue) => {
        navigate('/viewer', { state: { images, name, venue } });
    };


    return (
        <>
            <InternalBanner title="Snapshots " />
            <section className="gallery">
                <div className="container">
                    <div className="row mb-5">
                        <div className='col-md-12'>
                            {loading ? (
                                <SkelotonEffect />
                            ) : (

                                eventsByYear.map((yearData) => (
                                    <div className='main_gallery_images mb-4' key={yearData.year}>
                                        <div className='col-md-12'>
                                            <div className='year_strap mb-2'>YEAR {yearData.year}</div>
                                        </div>

                                        <div className='row row-cols-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-4 m-0 mt-4'>
                                            {yearData.events.map((event) => (
                                                <div className='col gallery_images mb-4' key={event.id}>
                                                    <img
                                                        src={event.image_thum || `${process.env.PUBLIC_URL}/assets/images/elements/folder.png`}
                                                        className='w-100'
                                                        alt={`Folder for ${event.name}`}
                                                        loading="lazy"
                                                        onClick={() => handleClick(event.images, event.name, event.venue)}
                                                    />
                                                    <div className='events'>
                                                        <h5 className='text-center text-capitalize mt-2'>{event.name}</h5>
                                                        <h6 className='text-center text-capitalize'>({event.venue})</h6>
                                                        <h6 className='text-center'>
                                                            {new Date(event.event_date).toLocaleDateString('en-GB', {
                                                                day: '2-digit',
                                                                month: 'long',
                                                                year: 'numeric',
                                                            })}
                                                        </h6>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                ))
                            )}


                        </div>
                    </div>
                </div>
            </section>

        </>
    );
}
